






























































































import Vue from "vue";
import Multiselect from "vue-multiselect";
import get from "lodash-es/get";
import moment from "moment";
import Checkbox from "./Checkbox.vue";
import Datepicker from "./Datepicker.vue";
import { FixedPeriodType, FilterValuesPeriod } from "../TypeScriptModels";

export default Vue.extend({
  components: {
    Multiselect,
    Datepicker,
    Checkbox
  },
  props: {
    dateformat: {
      type: String,
      default: "DD-MM-YYYY"
    },
    colspan: {
      type: Number,
      default: 6
    },
    showDataCompare: {
      type: Boolean,
      default: false
    },
    selectedOptions: {
      required: true,
      type: Object,
      default: () => {
        return {
          period: {} as null | any,
          periodFromDate: new Date(),
          periodToDate: new Date(),
          customFromDate: new Date(),
          customToDate: new Date(),
          comparePeriodData: false as boolean,
          customFromDateCompare: new Date(),
          customToDateCompare: new Date()
        };
      }
    }
  },

  data() {
    return {
      initialised: false,
      periodeOptions: [] as { Id: number; Omschrijving: string }[]
    };
  },

  created() {
    this.fillPerioden();
  },

  mounted() {
    this.$emit("ready", this.periodeOptions);
  },

  watch: {
    locale(newValue) {
      if (!!newValue) this.updatePerioden();
    },

    selectedPickerOption(newValue, oldValue) {
      this.handlePeriodChanged(newValue);
    }
  },

  computed: {
    locale(): string | null {
      return this.$store.getters.locale;
    },

    selectedPickerOption(): any {
      return get(this.selectedOptions, "period", this.periodeOptions[0]);
    },

    periodDateFrom(): string {
      return moment(this.selectedOptions.periodFromDate).format(
        this.dateformat
      );
    },

    periodDateTo(): string {
      return moment(this.selectedOptions.periodToDate).format(this.dateformat);
    },

    isCustomDateInput(): boolean {
      return this.dateOptionInput() === 1;
    },

    comparePeriodData: {
      get: function(): boolean {
        return !!this.selectedOptions && this.selectedOptions.comparePeriodData;
      },
      set: function(newValue: boolean) {
        if (!!this.selectedOptions)
          this.selectedOptions.comparePeriodData = newValue;
      }
    }
  },

  methods: {
    fillPerioden() {
      let perioden = [
        { Id: 1, Omschrijving: `${this.$i18n.t("timefilters.custom")}` },
        { Id: 2, Omschrijving: `${this.$i18n.t("timefilters.today")}` },
        { Id: 3, Omschrijving: `${this.$i18n.t("timefilters.yesterday")}` },
        { Id: 4, Omschrijving: `${this.$i18n.t("timefilters.thisweek")}` },
        { Id: 5, Omschrijving: `${this.$i18n.t("timefilters.lastweek")}` },
        { Id: 6, Omschrijving: `${this.$i18n.t("timefilters.thismonth")}` },
        { Id: 7, Omschrijving: `${this.$i18n.t("timefilters.lastmonth")}` },
        { Id: 8, Omschrijving: `${this.$i18n.t("timefilters.thisquarter")}` },
        { Id: 9, Omschrijving: `${this.$i18n.t("timefilters.lastquarter")}` },
        { Id: 10, Omschrijving: `${this.$i18n.t("timefilters.thisyear")}` },
        { Id: 11, Omschrijving: `${this.$i18n.t("timefilters.lastyear")}` }
      ];
      this.periodeOptions = perioden;
      this.$emit("options-changed", this.periodeOptions);
    },

    updatePerioden() {
      this.periodeOptions.forEach(
        (periode: { Id: any; Omschrijving: string }) => {
          switch (periode.Id) {
            case 1:
              periode.Omschrijving = `${this.$i18n.t("timefilters.custom")}`;
              break;
            case 2:
              periode.Omschrijving = `${this.$i18n.t("timefilters.today")}`;
              break;
            case 3:
              periode.Omschrijving = `${this.$i18n.t("timefilters.yesterday")}`;
              break;
            case 4:
              periode.Omschrijving = `${this.$i18n.t("timefilters.thisweek")}`;
              break;
            case 5:
              periode.Omschrijving = `${this.$i18n.t("timefilters.lastweek")}`;
              break;
            case 6:
              periode.Omschrijving = `${this.$i18n.t("timefilters.thismonth")}`;
              break;
            case 7:
              periode.Omschrijving = `${this.$i18n.t("timefilters.lastmonth")}`;
              break;
            case 8:
              periode.Omschrijving = `${this.$i18n.t(
                "timefilters.thisquarter"
              )}`;
              break;
            case 9:
              periode.Omschrijving = `${this.$i18n.t(
                "timefilters.lastquarter"
              )}`;
              break;
            case 10:
              periode.Omschrijving = `${this.$i18n.t("timefilters.thisyear")}`;
              break;
            case 11:
              periode.Omschrijving = `${this.$i18n.t("timefilters.lastyear")}`;
              break;
            default:
              break;
          }
        }
      );
      this.$emit("options-changed", this.periodeOptions);
    },

    handleChanged() {
      this.$emit("dates-changed");
    },

    dateOptionInput(): null | number {
      return get(this.selectedOptions.period, "Id", null);
    },

    handlePeriodChanged(newItem: any) {
      this.updateInputDates();
      this.handleChanged();
    },

    onCustomFromDateChanged(newDate: Date) {
      //om oneindige updateloops te voorkomen
      if (this.selectedOptions.customFromDate.getTime() === newDate.getTime())
        return;
     
      this.selectedOptions.customFromDate =newDate;
      if(this.selectedOptions.customToDate < newDate){
        this.selectedOptions.customToDate = newDate; 
      }

      let dayWrapper = moment(
        this.selectedOptions.customFromDate
      ).local().startOf("day");
      this.selectedOptions.customFromDate = dayWrapper.toDate();
      this.handleChanged();
    },

    onCustomToDateChanged(newDate: Date) {
       //om oneindige updateloops te voorkomen
      if (this.selectedOptions.customToDate.getTime() === newDate.getTime())
        return;

      this.selectedOptions.customToDate = newDate;
      if(this.selectedOptions.customFromDate > newDate){
         this.selectedOptions.customFromDate = newDate;   
      }   

      let dayWrapper = moment(
        this.selectedOptions.customToDate
      ).local().endOf("day");
      this.selectedOptions.customToDate = dayWrapper.toDate();

      this.handleChanged();
    },

    onComparePeriodDataChanged(newValue: boolean) {
      this.handleChanged();
    },

    onCustomFromDateCompareChanged(newDate: Date) {
      //om oneindige updateloops te voorkomen
      if (this.selectedOptions.customFromDateCompare.getTime() === newDate.getTime())
        return;

      this.selectedOptions.customFromDateCompare =newDate;
      if(this.selectedOptions.customToDateCompare < newDate){
        this.selectedOptions.customToDateCompare = newDate; 
      }

      let dayWrapper = moment(
        this.selectedOptions.customFromDateCompare
      ).local().startOf("day");
      this.selectedOptions.customFromDateCompare = dayWrapper.toDate();
 
      this.handleChanged();
    },

    onCustomToDateCompareChanged(newDate: Date) {
      //om oneindige updateloops te voorkomen
      if (this.selectedOptions.customToDateCompare.getTime() === newDate.getTime())
        return;

      this.selectedOptions.customToDateCompare = newDate;
      if(this.selectedOptions.customFromDateCompare > newDate){
         this.selectedOptions.customFromDateCompare = newDate;   
      }   

      let dayWrapper = moment(
        this.selectedOptions.customToDateCompare
      ).endOf("day");
      this.selectedOptions.customToDateCompare = dayWrapper.toDate();

      this.handleChanged();
    },

    updateInputDates() {
      if (this.isCustomDateInput) return;

      let initialFrom = moment()
        .local()
        .startOf("day");
      let initialTo = moment()
        .local()
        .endOf("day");
      switch (this.dateOptionInput()) {
        case FixedPeriodType.Today:
          break;
        case FixedPeriodType.Yesterday:
          initialFrom = initialFrom.subtract(1, "days");
          initialTo = initialTo.subtract(1, "days");
          break;
        case FixedPeriodType.ThisWeek:
          initialFrom = initialFrom
            .startOf("week") //default is sunday
            .add(1, "days");
          break;
        case FixedPeriodType.LastWeek:
          initialFrom = initialFrom
            .startOf("week") //default is sunday
            .add(1, "days")
            .subtract(7, "days")
            .startOf("day");
          initialTo = initialFrom
            .clone()
            .add(7, "days")
            .subtract(1, "second")
            .endOf("day");
          break;
        case FixedPeriodType.ThisMonth:
          initialFrom = initialFrom.startOf("month");
          break;
        case FixedPeriodType.LastMonth:
          initialFrom = initialFrom.subtract(1, "month").startOf("month");

          initialTo = initialFrom.clone().endOf("month");
          break;

        case FixedPeriodType.ThisQuarter:
          initialFrom = initialFrom.startOf("quarter");

          break;
        case FixedPeriodType.LastQuarter:
          const quarterAdjustment = (moment().month() % 3) + 1;
          let lastQuarterEndDate = moment()
            .subtract({ months: quarterAdjustment })
            .endOf("month");
          initialFrom = lastQuarterEndDate
            .clone()
            .add(1, "week")
            .subtract({ months: 3 })
            .startOf("month");

          initialTo = lastQuarterEndDate;
          break;
        case FixedPeriodType.ThisYear:
          initialFrom = initialFrom.startOf("year");

          break;

        case FixedPeriodType.LastYear:
          initialFrom = initialFrom
            .set({
              year: moment().year() - 1
            })
            .startOf("year");

          initialTo = initialTo
            .set({
              year: moment().year() - 1,
              month: 11
            })
            .endOf("year");
          break;
      }

      this.selectedOptions.periodFromDate = initialFrom.toDate();
      this.selectedOptions.periodToDate = initialTo.toDate();
    }
  }
});
